import $ from 'jquery';
import { getInputValue } from '../../utils/input';
import { matchesCriteria } from '../../utils/criteria';
const ELEMENT_SELECTOR = '.js__collection-select-on-target-value';
export class CollectionSelectOnTargetValue {
    static init($root = $('body')) {
        const $elements = $root.find(ELEMENT_SELECTOR);
        const $configuration = $('.js__configuration');
        $elements.each((index, element) => {
            let $element = $(element);
            const $target = $($element.data('target'));
            const initOnlyOnChange = $element.data('init-select-only-on-change');
            if ($element.hasClass('ui dropdown')) {
                $element = $element.find('select');
            }
            $target.on('change', event => {
                this.handleValueChange($(event.target), $element);
            });
            if (!initOnlyOnChange) {
                const value = getInputValue($target);
                $configuration.attr('data-type', value);
                const { criteriaValue, selectValue, disable, hideButtons, hideParentButtonsOnCriteriaValue, addOneCollectionOnCriteriaValue, } = $element.data();
                const criteriasMatch = criteriaValue
                    .split(',')
                    .map((criteria) => matchesCriteria(criteria.trim(), value));
                const selectValues = selectValue.split(',').map((selectValue) => selectValue);
                const criteriaMatchIndex = criteriasMatch.findIndex((criteriaMatch) => criteriaMatch);
                if (criteriaMatchIndex !== -1) {
                    this.matchedValueActions($element, selectValues[criteriaMatchIndex], criteriasMatch[criteriaMatchIndex], hideButtons, hideParentButtonsOnCriteriaValue, addOneCollectionOnCriteriaValue);
                }
            }
            const value = getInputValue($target);
            const { hideParentButtonsOnCriteriaValue } = $element.data();
            if (hideParentButtonsOnCriteriaValue && hideParentButtonsOnCriteriaValue.includes(value)) {
                $element.find('.js__add-action').last().hide();
                $element.find('.js__delete-action').last().hide();
            }
        });
    }
    static handleValueChange($target, $element) {
        const $configuration = $('.js__configuration');
        const value = getInputValue($target);
        const { criteriaValue, selectValue, disable, hideButtons, hideParentButtonsOnCriteriaValue, addOneCollectionOnCriteriaValue, } = $element.data();
        const criteriasMatch = criteriaValue.split(',').map((criteria) => matchesCriteria(criteria.trim(), value));
        const selectValues = selectValue.split(',').map((selectValue) => selectValue);
        const criteriaMatchIndex = criteriasMatch.findIndex((criteriaMatch) => criteriaMatch);
        $configuration.attr('data-type', value);
        $element
            .closest('.js__collection-wrapper')
            .find('select')
            .each(function () {
            $(this).closest('div[data-form-collection="item"]').remove();
        });
        this.toggleElement($element, criteriaMatchIndex !== -1 && criteriasMatch[criteriaMatchIndex], criteriaMatchIndex !== -1 && selectValues[criteriaMatchIndex], disable, hideButtons, hideParentButtonsOnCriteriaValue, addOneCollectionOnCriteriaValue);
    }
    static toggleElement($element, match, selectValue, disable, hideButtons, hideParentButtonsOnCriteriaValue, addOneCollectionOnCriteriaValue) {
        if (match) {
            this.matchedValueActions($element, selectValue, disable, hideButtons, hideParentButtonsOnCriteriaValue, addOneCollectionOnCriteriaValue, 50);
        }
        else {
            $element.find('.button').show();
        }
    }
    static matchedValueActions($element, selectValue, disable, hideButtons, hideParentButtonsOnCriteriaValue, addOneCollectionOnCriteriaValue, delay = 0) {
        const selectValues = selectValue.split('/').map((selectValue) => selectValue.trim());
        selectValues.forEach((selectValue, index) => {
            $element.find('.js__add-action').first().removeClass('disabled').prop('disabled', false).trigger('click');
            // @ts-ignore
            $($element.find('select').get(index)).val(selectValue).trigger('change');
            setTimeout(() => {
                if (disable) {
                    // @ts-ignore
                    $($element.find('select').get(index)).parent().addClass('disabled');
                }
                if (hideButtons) {
                    $element.find('.button').hide();
                }
                if (hideParentButtonsOnCriteriaValue) {
                    if (hideParentButtonsOnCriteriaValue.split(',').includes(selectValue)) {
                        $element.find('.js__add-action').last().hide();
                        $element.find('.js__delete-action').last().hide();
                    }
                    else {
                        $element.find('.js__add-action').last().show();
                        $element.find('.js__delete-action').last().show();
                    }
                }
                if (addOneCollectionOnCriteriaValue && addOneCollectionOnCriteriaValue.split(',').includes(selectValue)) {
                    $element.find('.js__add-action').first().trigger('click');
                }
            }, delay);
        });
    }
}
